import { Component, Input } from '@angular/core';
import * as debug from 'debug';

@Component({
  selector: 'stars',
  templateUrl: 'stars.html',
})
export class StarsComponent {
  @Input() width = 89;
  @Input() rating = 3.5;

  log = debug('app:StarsComponent');

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/stars/stars.ts